import { ActionPlanMeasurementType } from './../../enums/ActionPlanMeasurementType';

const getLabel: Record<ActionPlanMeasurementType, () => string> = {
  trainingRecord: () => 'Training record',
  roster: () => 'Roster',
  invoice: () => 'Invoice',
  sopUpdate: () => 'SOP Update',
  other: () => 'Other',
};

export function translateActionPlanMeasurementTypeLabel (
  type: ActionPlanMeasurementType
) {
  if (!type || !getLabel[type]) {
    return '';
  }
  return getLabel[type]();
}
